import styled from "styled-components";
import { useRecoilState } from "recoil";
import { LangState } from "../../atoms";
import { selectLang } from "../../lib/selectLang";
import { SideSheet, Paragraph } from "evergreen-ui";
import { Link } from "react-scroll";
import media from "../../lib/media";
import { useState } from "react";

function Navigation() {
  const [Lang, setLang] = useRecoilState(LangState);
  const [isShown, setIsShown] = useState(false);
  const { HeaderLang } = selectLang(Lang);
  // const ChangeLang = () => {
  //   setLang((prev) => !prev);
  // };
  const Meta = () => {
    alert("Comming soon");
  };

  return (
    <>
      <a href='#'>
        <Link to='Main' spy={true} smooth={true} offset={-80}>
          <li>{HeaderLang[0]}</li>
        </Link>
      </a>
      <a href=' https://docs.google.com/document/d/1GxDwnL90k_kOBrEfe_RVfXp1lincXCR5Gt6JCfwyFoc/edit?usp=sharing'>
        <li>{HeaderLang[1]}</li>
      </a>
      <a href='#'>
        <Link to='Team' spy={true} smooth={true} offset={-80}>
          <li>{HeaderLang[2]}</li>
        </Link>
      </a>
      <a href='https://github.com/DAIOSFoundation'>
        <li>{HeaderLang[3]}</li>
      </a>
      <a href='https://medium.com/@NXDF'>
        <li>{HeaderLang[4]}</li>
      </a>
      <a href='https://lucidex.io/#/market/4RnYHByMqmrmwu5M4aArX16nAKDg9RWh9Qo3yoRfd3Py'>
        <li>{HeaderLang[5]}</li>
      </a>
      <a href='https://metaaxel.online/'>
        <li>{HeaderLang[6]}</li>
      </a>
    </>
  );
}
export default Navigation;
